/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpErrorResponse, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable, of, throwError } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantDto as SecurityTenantDto } from '../../models/security/tenant-dto';

export interface GetTenantByAbbreviation$Params {
  abbreviation: string;
}

export function getTenantByAbbreviation(http: HttpClient, rootUrl: string, params: GetTenantByAbbreviation$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityTenantDto | undefined>> {
  const rb = new RequestBuilder(rootUrl, getTenantByAbbreviation.PATH, 'get');
  if (params) {
    rb.path('abbreviation', params.abbreviation, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecurityTenantDto | undefined>;
    }),
    catchError((e: unknown) => {
      if (e instanceof HttpErrorResponse && e.status === HttpStatusCode.NotFound) {
        const response = new HttpResponse({ status: e.status, statusText: e.statusText, headers: e.headers, url: e.url ?? undefined });
        // HttpResponse turns an undefined body into null
        return of(Object.assign(response, { body: undefined }) as StrictHttpResponse<SecurityTenantDto | undefined>);
      }
      return throwError(() => e);
    })
  );
}

getTenantByAbbreviation.PATH = '/tenant/{abbreviation}';

